import React, { useRef, useEffect } from "react";
import "./Authentication.css";
import authenticationGif from "../../assets/gif/authentication.gif";
import fixedHeropageGif from "../../assets/gif/SPT-Gamers-rotate2.GIF";
import DownloadOnGooglePlay from "../Buttons/DownloadOnGooglePlay";
import DownloadOnAppStore from "../Buttons/DownloadOnAppStore";
import DownloadOnAppStoreMobile from "../Buttons/DownloadOnAppStoreMobile";
import DownloadOnGooglePlayMobile from "../Buttons/DownloadOnGooglePlayMobile";
import { useTranslation } from "react-i18next";
const Authentication = () => {
  const { t } = useTranslation();
  const fixedHeropageGifRef = useRef(0);
  const handleSecondScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition <= 3105) {
      fixedHeropageGifRef.current.style = "display: none";
    } else if (scrollPosition >= 3105) {
      fixedHeropageGifRef.current.style = "display: block";
    }
    // console.log(scrollPosition);
  };
  window.addEventListener("scroll", console.log(window.scrollY));
  // window.addEventListener("scroll", handleSecondScroll);
  useEffect(() => {
    window.addEventListener("scroll", handleSecondScroll);

    return () => {
      window.removeEventListener("scroll", handleSecondScroll);
    };
  }, [fixedHeropageGifRef]);
  return (
    <div className="authentication-container" id="authentication">
      <div className="authentication-details">
        <div className="authentication-text">
          <h3>
            3 {t("WAYS")} {t("AUTHENTICATION")} {t("TO")} {t("STRENGTHEN")}{" "}
            {t("YOUR")} {t("ASSETS")} {t("SAFETY")}.
          </h3>
          <p>
            {t("Download")} <strong>GAMERS WALLET</strong> {t("today")},{" "}
            {t("and")} {t("enjoy")} {t("all")} {t("this")} {t("amazing")}{" "}
            {t("functionalities")}
          </p>
        </div>
        <div className="auth-buttons">
          <DownloadOnAppStoreMobile />
          <DownloadOnGooglePlayMobile />
          <DownloadOnGooglePlay />
          <DownloadOnAppStore />
        </div>
        <div className="auth-gif">
          <img
            src={fixedHeropageGif}
            alt="fixed heropage-gif"
            className="fixed-heropage-gif"
            ref={fixedHeropageGifRef}
          />
          <img
            src={authenticationGif}
            alt="Authentication-Gif"
            className="auth-main-gif"
          />
        </div>
      </div>
    </div>
  );
};

export default Authentication;
